import * as _ from "lodash";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { LgConsole } from "@logex/framework/core";
import {
    DefinitionsAddressType,
    DefinitionsContactType,
    DefinitionsCountry,
    DefinitionsHealthcareServiceProviderCategory,
    DefinitionsHealthcareServiceSupplierCategory,
    DefinitionsHierarchyType,
    DefinitionsNumberOfBeds,
    DefinitionsOrganizationNameTag,
    DefinitionsOrganizationType,
    DefinitionsRegulationCode
} from "../types/app-definitions";
import { map } from "rxjs/operators";
import { BrowserCacheProvider, ServerGatewayBase } from "@logex/framework/lg-application";

@Injectable({ providedIn: "root" })
export class DefinitionsGateway extends ServerGatewayBase {
    _baseUrl = "/api/v1.0/definitions/";

    constructor(
        _httpClient: HttpClient,
        _cacheProvider: BrowserCacheProvider,
        _console: LgConsole
    ) {
        super();
        this._fakeCache = false;
    }

    getAddressType(): Observable<_.Dictionary<DefinitionsAddressType>> {
        return this.get<DefinitionsAddressType[]>(`address-type`).pipe(
            map(res => _.keyBy(res, item => item.code))
        );
    }

    getContactType(): Observable<_.Dictionary<DefinitionsContactType>> {
        return this.get<DefinitionsContactType[]>(`contact-type`).pipe(
            map(res => _.keyBy(res, item => item.code))
        );
    }

    getCountry(): Observable<_.Dictionary<DefinitionsCountry>> {
        return this.get<DefinitionsCountry[]>(`country`).pipe(
            map(res => _.keyBy(res, item => item.code))
        );
    }

    getHealthcareServiceProviderCategory(): Observable<
        _.Dictionary<DefinitionsHealthcareServiceProviderCategory>
    > {
        return this.get<DefinitionsHealthcareServiceProviderCategory[]>(
            `healthcare-service-provider-category`
        ).pipe(map(res => _.keyBy(res, item => item.code)));
    }

    getHealthcareServiceSupplierCategory(): Observable<
        _.Dictionary<DefinitionsHealthcareServiceSupplierCategory>
    > {
        return this.get<DefinitionsHealthcareServiceSupplierCategory[]>(
            `healthcare-service-supplier-category`
        ).pipe(map(res => _.keyBy(res, item => item.code)));
    }

    getOrganizationType(): Observable<_.Dictionary<DefinitionsOrganizationType>> {
        return this.get<DefinitionsOrganizationType[]>(`organization-type`).pipe(
            map(res => _.keyBy(res, item => item.code))
        );
    }

    getOrganizationNameTag(): Observable<_.Dictionary<DefinitionsOrganizationNameTag>> {
        return this.get<DefinitionsOrganizationNameTag[]>(`organization-name-tag`).pipe(
            map(res => _.keyBy(res, item => item.code))
        );
    }

    getOrganizationHierarchyType(): Observable<_.Dictionary<DefinitionsHierarchyType>> {
        return this.get<DefinitionsHierarchyType[]>(`organization-hierarchy-type`).pipe(
            map(res => _.keyBy(res, item => item.code))
        );
    }

    getRegulationCode(): Observable<_.Dictionary<DefinitionsRegulationCode>> {
        return this.get<DefinitionsRegulationCode[]>(`regulation-code`).pipe(
            map(res => _.keyBy(res, item => item.code))
        );
    }

    getNumberOfBeds(): Observable<_.Dictionary<DefinitionsNumberOfBeds>> {
        return this.get<DefinitionsNumberOfBeds[]>(`number-of-beds`).pipe(
            map(res => _.keyBy(res, item => item.id))
        );
    }
}
